var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.labels && _vm.labels.length > 0)?_c('div',{staticClass:"flex flex-wrap w-full",class:[
        {'justify-start' : _vm.align === 'left'},
        {'justify-center' : _vm.align === 'center'},
        {'md:justify-end' : _vm.align === 'right'},
        {'justify-between' : _vm.align === 'between'}
    ]},_vm._l((_vm.labels),function(label){return _c('div',{key:label.id},[_c('label-pill',{staticClass:"mr-1 mb-1",attrs:{"label":label,"size":"small","isClickable":_vm.isClickable},on:{"label-clicked":function($event){return _vm.$emit('label-clicked', label)}}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }